// ? version 1.3
function extractImageIndexFromFilename(filename) {
  const match = filename.match(/index_(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}

function extractOptionsFromFilename(filename) {
  const options = [];
  const regex = /option_([a-zA-Z0-9-]+)_([a-zA-Z0-9-]+)/g;
  let match;
  while ((match = regex.exec(filename))) {
    const optionKey = match[1].replace(/_/g, ' ').replace(/\b\w/g, char => char.toLowerCase());
    const optionValue = match[2].replace(/_/g, ' ').replace(/\b\w/g, char => char.toLowerCase());
    options.push({ key: optionKey, value: optionValue });
  }
  return options;
}

function getFilenameFromUrl(url) {
  return url.split('?')[0].split('/').pop();
}

function isVideo(filename) {
  return /\.(mp4|webm|mov|ogg)$/i.test(filename);
}

function isModel3D(filename) {
  return /\.(glb|gltf)$/i.test(filename);
}

function compareOptions(optionsInFilename, optionsWithKeys) {
  if (optionsInFilename.length === 0) return true;

  return optionsInFilename.every(optionInFile => {
    return Object.keys(optionsWithKeys).some(optionKey => {
      const normalizedKey = optionKey.toLowerCase().replace(/\s+/g, '-');
      const normalizedValue = optionsWithKeys[optionKey]?.toLowerCase().replace(/\s+/g, '-') || '';
      return optionInFile.key === normalizedKey && optionInFile.value === normalizedValue;
    });
  });
}

let mediaList = [];
let mediaToHide = allVariantMetafields.map((media) => media.image);
let currentIndex = 0;
let flickitySlider = null;
let lightbox = null;
let isUpdatingGallery = false;
let mobileGalleryHeight = null;
let isInitialLoad = true;
let isGalleryExpanded = false; // Track if gallery is expanded

// Pobierz dane o mediach z JSON wygenerowanego przez Liquid
function getProductMediaData() {
  const el = document.getElementById('product-media-json');
  if (!el) return [];
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return [];
  }
}
const productMediaData = getProductMediaData();

function updateVariantGallery() {
  if (isUpdatingGallery) return;
  isUpdatingGallery = true;

  const variantGallery = document.querySelector('[data-name="variant-gallery"]');
  if (!variantGallery) {
    isUpdatingGallery = false;
    return;
  }

  const currentVariantId = document.querySelector('[name="id"]')?.value;
  const currentVariant = allVariantMetafields.find(variant => variant.id == currentVariantId);

  if (!currentVariant) {
    isUpdatingGallery = false;
    return;
  }

  // Reset mediaList before updating gallery
  mediaList = [];

  // Remove placeholder galleries
  const placeholders = variantGallery.querySelectorAll('.gallery-placeholder');
  placeholders.forEach(placeholder => placeholder.remove());

  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    variantGallery.innerHTML = '<div class="gallery-slider"></div>';
    const gallerySlider = variantGallery.querySelector('.gallery-slider');
    createMobileGallery(currentVariant, gallerySlider);
  } else {
    variantGallery.innerHTML = '<div class="gallery-grid"></div>';
    const galleryWrapper = variantGallery.querySelector('.gallery-grid');
    createDesktopGallery(currentVariant, galleryWrapper);
  }

  // Initialize lightbox if it doesn't exist
  if (!lightbox) {
    initializeLightbox();
  }

  // Update lightbox content if it's active
  if (lightbox?.classList.contains('active')) {
    currentIndex = Math.min(currentIndex, mediaList.length - 1);
    updateLightboxContent();
  }

  isUpdatingGallery = false;
}

function createMobileGallery(currentVariant, gallerySlider) {
  mediaList = [];

  // Najpierw spróbuj użyć featured_media.id, potem fallback do image
  if (currentVariant.featured_media && currentVariant.featured_media.id) {
    const variantImg = createMediaElement(currentVariant.featured_media.id);
    // Add badge to first image if exists
    addBadgeToFirstImage(variantImg);
    gallerySlider.appendChild(variantImg);
    mediaList.push(currentVariant.featured_media.id);
  } else if (currentVariant.image) {
    const variantImg = createMediaElement(currentVariant.image);
    // Add badge to first image if exists
    addBadgeToFirstImage(variantImg);
    gallerySlider.appendChild(variantImg);
    mediaList.push(currentVariant.image);
  }

  // Znajdź pierwsze wideo w mediach produktu
  let firstVideo = null;
  if (currentVariant.productMedia) {
    for (const media of currentVariant.productMedia) {
      const filename = getFilenameFromUrl(media);
      if (isVideo(filename)) {
        firstVideo = media;
        break;
      }
    }
  }

  const allSortedMedia = getSortedMedia(currentVariant, firstVideo);

  allSortedMedia.forEach((image, index) => {
    if (mediaToHide.includes(image)) return;

    const filename = getFilenameFromUrl(image.toLowerCase());
    const optionsInFilename = extractOptionsFromFilename(filename);
    const isMatch = compareOptions(optionsInFilename, currentVariant.optionsWithKeys);

    if (isMatch) {
      if (index === 0 && firstVideo) {
        const videoElement = createMediaElement(firstVideo);
        gallerySlider.appendChild(videoElement);
        mediaList.push(firstVideo);
        firstVideo = null;
      }
      const mediaElement = createMediaElement(image);
      gallerySlider.appendChild(mediaElement);
      mediaList.push(image);
    }
  });

  if (firstVideo && mediaList.length >= 1) {
    const videoElement = createMediaElement(firstVideo);
    gallerySlider.insertBefore(videoElement, gallerySlider.children[1] || null);
    mediaList.splice(1, 0, firstVideo);
  }

  let startX = 0, startY = 0, isHorizontal = false;
  gallerySlider.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isHorizontal = false;
  }, { passive: true });
  gallerySlider.addEventListener('touchmove', e => {
    const dx = Math.abs(e.touches[0].clientX - startX);
    const dy = Math.abs(e.touches[0].clientY - startY);
    if (!isHorizontal && dx > 10 && dx > dy) {
      isHorizontal = true;
    }
    if (isHorizontal) {
      e.preventDefault();
    }
  }, { passive: false });

  // Initialize Flickity
  if (flickitySlider) {
    const currentSlide = flickitySlider.selectedIndex;
    flickitySlider.destroy();
    flickitySlider = new Flickity(gallerySlider, {
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: false,
      initialIndex: Math.min(currentSlide, mediaList.length - 1),
      watchCSS: false,
      setGallerySize: true,
      dragThreshold: 40,
      selectedAttraction: 0.02,
      friction: 0.26,
      percentPosition: false,
      freeScroll: false,
      wrapAround: false,
      lazyLoad: false,
      imagesLoaded: false
    });
  } else {
    flickitySlider = new Flickity(gallerySlider, {
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: false,
      watchCSS: false,
      setGallerySize: true,
      dragThreshold: 40,
      selectedAttraction: 0.02,
      friction: 0.26,
      percentPosition: false,
      freeScroll: false,
      wrapAround: false,
      lazyLoad: false,
      imagesLoaded: false
    });
  }

  // Funkcja do obliczania i ustawiania stałej wysokości galerii mobilnej
  setMobileGalleryHeight(gallerySlider);

  // Preload next images on mobile for smoother swiping
  if (window.innerWidth < 768 && mediaList.length > 1) {
    // Preload next 2-3 images
    const preloadCount = Math.min(3, mediaList.length - 1);
    for (let i = 1; i <= preloadCount; i++) {
      const preloadImg = new Image();
      preloadImg.src = mediaList[i];
    }

    // Preload all images in background for mobile gallery
    setTimeout(() => {
      mediaList.forEach((mediaSrc, index) => {
        if (index > preloadCount) {
          const preloadImg = new Image();
          preloadImg.src = mediaSrc;
        }
      });
    }, 1000); // Start preloading after 1 second
  }

  // --- MOBILE: własna obsługa tap/swipe na obrazkach ---
  if (window.innerWidth < 768) {
    const galleryItems = gallerySlider.querySelectorAll('.gallery-item');
    galleryItems.forEach((item, index) => {
      let tapStartX = 0, tapStartY = 0, tapStartTime = 0;
      item.addEventListener('touchstart', (e) => {
        if (e.touches.length === 1) {
          tapStartX = e.touches[0].clientX;
          tapStartY = e.touches[0].clientY;
          tapStartTime = Date.now();
        }
      }, { passive: true });
      item.addEventListener('touchend', (e) => {
        if (e.changedTouches.length === 1) {
          const dx = Math.abs(e.changedTouches[0].clientX - tapStartX);
          const dy = Math.abs(e.changedTouches[0].clientY - tapStartY);
          const dt = Date.now() - tapStartTime;
          if (dx < 15 && dy < 15 && dt > 40 && dt < 400) {
            // To jest tap, otwórz lightbox
            if (!lightbox) initializeLightbox();
            lightbox.classList.add('active');
            currentIndex = index;
            updateLightboxContent();
          }
        }
      });
    });
  } else {
    // --- DESKTOP: Flickity staticClick ---
    if (flickitySlider) {
      flickitySlider.on('staticClick', function (event, pointer, cellElement, cellIndex) {
        if (cellElement) {
          if (!lightbox) {
            initializeLightbox();
          }
          lightbox.classList.add('active');
          currentIndex = cellIndex;
          updateLightboxContent();
        }
      });
    }
  }
}

function createDesktopGallery(currentVariant, galleryWrapper) {
  mediaList = [];

  // Najpierw spróbuj użyć featured_media.id, potem fallback do image
  if (currentVariant.featured_media && currentVariant.featured_media.id) {
    const variantImg = createMediaElement(currentVariant.featured_media.id);
    // Add badge to first image if exists
    addBadgeToFirstImage(variantImg);
    galleryWrapper.appendChild(variantImg);
    mediaList.push(currentVariant.featured_media.id);
  } else if (currentVariant.image) {
    const variantImg = createMediaElement(currentVariant.image);
    // Add badge to first image if exists
    addBadgeToFirstImage(variantImg);
    galleryWrapper.appendChild(variantImg);
    mediaList.push(currentVariant.image);
  }

  // Znajdź pierwsze wideo w mediach produktu
  let firstVideo = null;
  if (currentVariant.productMedia) {
    for (const media of currentVariant.productMedia) {
      const filename = getFilenameFromUrl(media);
      if (isVideo(filename)) {
        firstVideo = media;
        break;
      }
    }
  }

  const allSortedMedia = getSortedMedia(currentVariant, firstVideo);

  allSortedMedia.forEach((image, index) => {
    if (mediaToHide.includes(image)) return;

    const filename = getFilenameFromUrl(image.toLowerCase());
    const optionsInFilename = extractOptionsFromFilename(filename);
    const isMatch = compareOptions(optionsInFilename, currentVariant.optionsWithKeys);

    if (isMatch) {
      if (index === 0 && firstVideo) {
        const videoElement = createMediaElement(firstVideo);
        galleryWrapper.appendChild(videoElement);
        mediaList.push(firstVideo);
        firstVideo = null;
      }
      const mediaElement = createMediaElement(image);
      galleryWrapper.appendChild(mediaElement);
      mediaList.push(image);
    }
  });

  if (firstVideo && mediaList.length >= 1) {
    const videoElement = createMediaElement(firstVideo);
    galleryWrapper.insertBefore(videoElement, galleryWrapper.children[1] || null);
    mediaList.splice(1, 0, firstVideo);
  }

  // Add "View more" button if there are more than 6 images
  if (mediaList.length > 6) {
    const viewMoreButton = document.createElement('button');
    viewMoreButton.classList.add('view-more-button', 'button', 'black', 'outline', 'visible');
    viewMoreButton.textContent = `View more images (${mediaList.length - 6})`;
    galleryWrapper.parentNode.appendChild(viewMoreButton);

    // Apply saved state if gallery was expanded
    if (isGalleryExpanded) {
      const hiddenItems = galleryWrapper.querySelectorAll('.gallery-item:nth-child(n+7)');
      hiddenItems.forEach(item => item.classList.add('show'));
      viewMoreButton.textContent = 'Show less';
    }

    viewMoreButton.addEventListener('click', () => {
      const hiddenItems = galleryWrapper.querySelectorAll('.gallery-item:nth-child(n+7)');
      hiddenItems.forEach(item => item.classList.toggle('show'));
      isGalleryExpanded = !isGalleryExpanded;
      viewMoreButton.textContent = isGalleryExpanded ? 'Show less' : `View more images (${mediaList.length - 6})`;

      // Scroll handling
      if (isGalleryExpanded) {
        // When expanding, scroll to the first hidden image
        const firstHiddenItem = hiddenItems[0];
        if (firstHiddenItem) {
          setTimeout(() => {
            firstHiddenItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 100);
        }
      } else {
        // When collapsing, scroll back to gallery top
        setTimeout(() => {
          galleryWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    });
  }

  // Preload first few images on desktop for better UX
  if (window.innerWidth >= 768 && mediaList.length > 1) {
    // Preload first 3-4 images
    const preloadCount = Math.min(4, mediaList.length);
    for (let i = 0; i < preloadCount; i++) {
      const preloadImg = new Image();
      preloadImg.src = mediaList[i];
    }
  }

  addClickEventToImages(galleryWrapper, mediaList);
}

function getSortedMedia(currentVariant, firstVideo) {
  return currentVariant.productMedia
    .filter(media => {
      const filename = getFilenameFromUrl(media);
      // Wyklucz wideo z sortowania po index, bo wideo ma być na drugiej pozycji
      return !isVideo(filename);
    })
    .map(media => ({
      media,
      index: extractImageIndexFromFilename(getFilenameFromUrl(media)),
      options: extractOptionsFromFilename(getFilenameFromUrl(media))
    }))
    .sort((a, b) => (a.index || Infinity) - (b.index || Infinity))
    .map(item => item.media);
}

function createMediaElement(mediaSrcOrId) {
  const wrapper = document.createElement('div');
  wrapper.classList.add('gallery-item', 'lightbox-trigger');

  // Szukaj mediaData - najpierw po ID, potem po nazwie pliku
  let mediaData = null;
  let mediaSrc = mediaSrcOrId;

  // Jeśli przekazano ID (liczba lub string z liczbą)
  if (typeof mediaSrcOrId === 'number' || /^\d+$/.test(mediaSrcOrId)) {
    mediaData = productMediaData.find(m => m.id == mediaSrcOrId);
    // Jeśli znaleziono po ID, użyj src1200 jako mediaSrc
    if (mediaData) {
      mediaSrc = mediaData.src1200;
    }
  }

  // Jeśli nie znaleziono po ID i to string (URL), szukaj po nazwie pliku
  if (!mediaData && typeof mediaSrcOrId === 'string') {
    function stripSizeAndParams(url) {
      return url.replace(/_[0-9]+x[0-9]+/, '').split('?')[0];
    }
    const srcStripped = stripSizeAndParams(mediaSrcOrId);
    mediaData = productMediaData.find(m => {
      const mStripped = stripSizeAndParams(m.src1200);
      return mStripped === srcStripped;
    });
  }

  const filename = getFilenameFromUrl(mediaSrc);

  if (isVideo(filename)) {
    const video = document.createElement('video');
    video.src = mediaSrc;
    video.controls = false;
    video.muted = true;
    video.setAttribute('muted', '');
    video.autoplay = true;
    video.setAttribute('autoplay', '');
    video.loop = true;
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.classList.add('product-gallery-video');
    video.addEventListener('loadeddata', () => {
      wrapper.classList.add('loaded');
    });
    video.addEventListener('error', (e) => {
      console.error('Video error:', mediaSrc, e);
    });
    wrapper.appendChild(video);
  } else if (isModel3D(filename)) {
    const modelViewer = document.createElement('model-viewer');
    modelViewer.setAttribute('src', mediaSrc);
    modelViewer.setAttribute('camera-controls', 'true');
    modelViewer.setAttribute('ar', '');
    modelViewer.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
    modelViewer.setAttribute('data-shopify-feature', '1.12');
    modelViewer.setAttribute('alt', '3D model alt description');
    if (mediaData && mediaData.lqip) {
      modelViewer.setAttribute('poster', mediaData.lqip);
    }
    modelViewer.style.height = "100%";
    modelViewer.addEventListener('load', () => {
      wrapper.classList.add('loaded');
    });
    wrapper.appendChild(modelViewer);
  } else if (mediaData) {
    // Tworzymy <picture> z danymi z JSON
    const picture = document.createElement('picture');

    // WebP source
    const sourceWebp = document.createElement('source');
    sourceWebp.type = 'image/webp';
    sourceWebp.srcset = mediaData.webp_srcset;
    sourceWebp.sizes = window.innerWidth < 768 ? '100vw' : '(max-width: 768px) 100vw, 50vw';
    picture.appendChild(sourceWebp);

    // Oryginalny format
    const sourceOrig = document.createElement('source');
    sourceOrig.type = mediaData.mime_type || 'image/jpeg';
    sourceOrig.srcset = mediaData.original_srcset;
    sourceOrig.sizes = window.innerWidth < 768 ? '100vw' : '(max-width: 768px) 100vw, 50vw';
    picture.appendChild(sourceOrig);

    // IMG z LQIP jako tło
    const img = document.createElement('img');
    img.className = 'product-gallery__img';
    img.style.backgroundImage = `url('${mediaData.lqip}')`;
    img.src = mediaData.src1200;
    img.alt = mediaData.alt || '';
    img.width = 1200;
    img.height = 1200;
    // Na mobile używaj eager loading dla wszystkich obrazków w galerii, na desktop lazy loading
    img.loading = window.innerWidth < 768 ? 'eager' : (typeof mediaSrcOrId === 'number' || /^\d+$/.test(mediaSrcOrId) ? 'eager' : 'lazy');
    img.decoding = 'async';
    img.onload = () => {
      img.classList.add('loaded');
      wrapper.classList.add('loaded');
    };
    picture.appendChild(img);

    wrapper.appendChild(picture);
  } else {
    // fallback: zwykły obrazek
    const img = document.createElement('img');
    img.loading = 'lazy';
    img.classList.add('product-gallery-image');
    img.src = mediaSrc;
    img.alt = '';
    img.onload = () => wrapper.classList.add('loaded');
    wrapper.appendChild(img);
  }
  return wrapper;
}

function addClickEventToImages(galleryWrapper, mediaList) {
  const mediaElements = galleryWrapper.querySelectorAll('img, video');
  mediaElements.forEach((media, index) => {
    media.dataset.index = index;
    media.addEventListener('click', () => {
      // Make sure lightbox exists before trying to use it
      if (!lightbox) {
        initializeLightbox();
      }
      lightbox.classList.add('active');
      currentIndex = parseInt(media.dataset.index);
      updateLightboxContent();
    });
  });
}

function initializeLightbox() {
  // Remove old lightbox if it exists
  if (lightbox) {
    lightbox.remove();
  }

  lightbox = document.createElement('div');
  lightbox.classList.add('lightbox');
  lightbox.innerHTML = `
    <div class="lightbox-content">
      <button class="lightbox-prev" type="button" aria-label="Previous"></button>
      <div class="lightbox-media"></div>
      <button class="lightbox-next" type="button" aria-label="Next"></button>
      <button class="lightbox-close">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 13L7 7M7 7L13 1M7 7L13 13M7 7L1 1" stroke="#666666" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round"></path>
        </svg>
      </button>

      <div class="lightbox-counter"></div>

      <!-- Mobile zoom hint -->
      <div class="lightbox-zoom-hint">
        <div class="zoom-hint-icon">
          <svg width="22" height="22" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.2637 82.9199C17.2234 71.9255 23.5869 48.4145 25.3633 42.3254C27.5837 34.714 30.3932 23.3517 34.4423 20.4196C37.1261 18.4762 48.1515 14.8153 55.2821 12.5672C59.4193 11.2629 63.7326 10.6455 68.0705 10.6455H79.1503C82.3735 10.6455 84.9864 13.2584 84.9864 16.4816V16.4816C84.9864 19.6164 82.5099 22.1913 79.3775 22.3134L67.6377 22.7707C64.9047 22.8772 62.2319 23.6051 59.8222 24.8992L51.7577 29.2301C46.377 32.1198 45.3758 39.4155 49.7791 43.6478L50.9838 44.8057C53.348 47.0781 57.0988 47.0314 59.4057 44.7009L66.5599 37.4738C68.1043 35.9136 70.0771 34.8298 72.2524 34.5345C73.9113 34.3093 75.8416 34.1251 77.1674 34.2421C78.373 34.3486 79.979 34.8622 81.4219 35.636C84.5602 37.3191 83.3266 40.9 80.3006 42.7777C77.4639 44.538 74.0741 46.8455 71.4428 50.299C69.6277 53.138 66.2766 59.8024 64.7408 62.5859C62.5529 66.5515 56.3473 72.2581 45.7305 73.1476C45.3237 73.1817 44.9699 73.4514 44.8419 73.839L41.8424 82.9199" stroke="#666" stroke-width="4" stroke-linecap="round"/>
          </svg>
        </div>
        <span class="zoom-hint-text">Pinch to zoom</span>
      </div>
    </div>
  `;
  document.body.appendChild(lightbox);

  const lightboxMedia = lightbox.querySelector('.lightbox-media');
  const prevButton = lightbox.querySelector('.lightbox-prev');
  const nextButton = lightbox.querySelector('.lightbox-next');
  const closeButton = lightbox.querySelector('.lightbox-close');
  const counter = lightbox.querySelector('.lightbox-counter');
  const zoomHint = lightbox.querySelector('.lightbox-zoom-hint');

  let zoomActive = false;
  let dragging = false, startX = 0, startY = 0, offsetX = 0, offsetY = 0;
  let isInTouchEvent = false; // Flag to prevent hiding hint during touch events

  // Hide zoom hint
  function hideZoomHint() {
    if (zoomHint && window.innerWidth < 768) {
      zoomHint.classList.add('hidden');
    }
  }

  // Show zoom hint
  function showZoomHint() {
    if (zoomHint && window.innerWidth < 768) {
      zoomHint.classList.remove('hidden');
    }
  }

  // Show zoom hint only on mobile
  if (window.innerWidth < 768) {
    // Auto-hide after 10 seconds
    setTimeout(hideZoomHint, 10000);
  } else {
    // Hide on desktop
    hideZoomHint();
  }

  function enableZoom(img) {
    zoomActive = true;
    img.classList.add('zoomed');
    img.style.cursor = window.innerWidth < 768 ? 'default' : 'zoom-out';
    img.style.transition = 'none';
    img.style.transform = 'scale(2)';
    img.draggable = false;
    offsetX = 0;
    offsetY = 0;
    dragging = false;

    // Desktop: mousemove = zoom pod kursorem, ogranicz przesuwanie do krawędzi
    function onMouseMove(e) {
      if (window.innerWidth < 768) return;
      const rect = img.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      let xPercent = x / rect.width;
      let yPercent = y / rect.height;
      // Ogranicz do 0.25-0.75 (żeby nie wyjeżdżać poza krawędź)
      xPercent = Math.max(0, Math.min(1, xPercent));
      yPercent = Math.max(0, Math.min(1, yPercent));
      const tx = (0.5 - xPercent) * 50; // -15% do 15% (delikatniej)
      const ty = (0.5 - yPercent) * 50;
      img.style.transform = `scale(2) translate(${tx}%, ${ty}%)`;
    }

    // Mobile: pinch zoom and pan
    let initialDistance = 0;
    let initialScale = 1;
    let currentScale = 1;
    let initialCenterX = 0;
    let initialCenterY = 0;
    let currentCenterX = 0;
    let currentCenterY = 0;

    function getDistance(touches) {
      const dx = touches[0].clientX - touches[1].clientX;
      const dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function getCenter(touches) {
      return {
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2
      };
    }

    function onTouchStart(e) {
      if (window.innerWidth >= 768) return;

      if (e.touches.length === 1) {
        // Single touch - pan mode
        dragging = true;
        const touch = e.touches[0];
        startX = touch.clientX - offsetX;
        startY = touch.clientY - offsetY;
      } else if (e.touches.length === 2) {
        // Two touches - pinch zoom mode
        e.preventDefault();
        initialDistance = getDistance(e.touches);
        initialScale = currentScale;
        const center = getCenter(e.touches);
        const rect = img.getBoundingClientRect();
        initialCenterX = center.x - rect.left;
        initialCenterY = center.y - rect.top;
        currentCenterX = initialCenterX;
        currentCenterY = initialCenterY;
      }
    }

    function onTouchMove(e) {
      if (e.touches.length === 1 && dragging && zoomActive) {
        const touch = e.touches[0];
        offsetX = (touch.clientX - startX) * 0.7;
        offsetY = (touch.clientY - startY) * 0.7;
        const maxOffset = img.width * (currentScale - 1) * 0.5;
        offsetX = Math.max(Math.min(offsetX, maxOffset), -maxOffset);
        offsetY = Math.max(Math.min(offsetY, maxOffset), -maxOffset);
        img.style.transform = `scale(${currentScale}) translate(${offsetX}px, ${offsetY}px)`;
        e.preventDefault();
      } else if (e.touches.length === 2) {
        e.preventDefault();
        zoomActive = true;
        const distance = getDistance(e.touches);
        const scale = distance / initialDistance;
        let targetScale = Math.max(1, Math.min(2.4, initialScale * scale));
        currentScale = currentScale + (targetScale - currentScale) * 0.2;
        const center = getCenter(e.touches);
        const rect = img.getBoundingClientRect();
        currentCenterX = center.x - rect.left;
        currentCenterY = center.y - rect.top;
        const scaleDiff = currentScale - 1;
        const centerOffsetX = (currentCenterX - initialCenterX) * scaleDiff;
        const centerOffsetY = (currentCenterY - initialCenterY) * scaleDiff;
        img.style.transform = `scale(${currentScale}) translate(${offsetX + centerOffsetX}px, ${offsetY + centerOffsetY}px)`;
      }
    }

    function onTouchEnd(e) {
      if (window.innerWidth >= 768) return;

      if (e.touches.length === 0) {
        dragging = false;
        // Reset to minimum scale if zoomed out too much
        if (currentScale < 1.1) {
          currentScale = 1;
          offsetX = 0;
          offsetY = 0;
          img.style.transform = 'scale(1)';
          disableZoom(img);
        }
      }
    }

    img.addEventListener('mousemove', onMouseMove);
    img.addEventListener('touchstart', onTouchStart, { passive: false });
    img.addEventListener('touchmove', onTouchMove, { passive: false });
    img.addEventListener('touchend', onTouchEnd);
    img.addEventListener('touchcancel', onTouchEnd);
    img._zoomListeners = { onMouseMove, onTouchStart, onTouchMove, onTouchEnd };
  }
  function disableZoom(img) {
    zoomActive = false;
    img.classList.remove('zoomed');
    img.style.cursor = window.innerWidth < 768 ? 'default' : 'zoom-in';
    img.style.transition = '';
    img.style.transform = '';
    img.draggable = true;
    // Reset zoom variables
    offsetX = 0;
    offsetY = 0;
    dragging = false;
    if (img._zoomListeners) {
      img.removeEventListener('mousemove', img._zoomListeners.onMouseMove);
      img.removeEventListener('touchstart', img._zoomListeners.onTouchStart);
      img.removeEventListener('touchmove', img._zoomListeners.onTouchMove);
      img.removeEventListener('touchend', img._zoomListeners.onTouchEnd);
      img.removeEventListener('touchcancel', img._zoomListeners.onTouchEnd);
      delete img._zoomListeners;
    }
  }

  function updateLightboxContent() {
    if (!mediaList[currentIndex]) {
      lightbox.classList.remove('active');
      return;
    }
    lightboxMedia.innerHTML = '';
    const filename = getFilenameFromUrl(mediaList[currentIndex]);
    if (isVideo(filename)) {
      const video = document.createElement('video');
      video.src = mediaList[currentIndex];
      video.controls = true;
      video.muted = true;
      video.setAttribute('muted', '');
      video.autoplay = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      lightboxMedia.appendChild(video);
    } else if (isModel3D(filename)) {
      const modelViewer = document.createElement('model-viewer');
      modelViewer.src = mediaList[currentIndex];
      modelViewer.autoRotate = true;
      modelViewer.cameraControls = true;
      lightboxMedia.appendChild(modelViewer);
    } else {
      // Znajdź mediaData dla aktualnego obrazu
      let mediaData = null;
      const currentMediaSrc = mediaList[currentIndex];

      // Szukaj po nazwie pliku
      function stripSizeAndParams(url) {
        return url.replace(/_[0-9]+x[0-9]+/, '').split('?')[0];
      }
      const srcStripped = stripSizeAndParams(currentMediaSrc);
      mediaData = productMediaData.find(m => {
        const mStripped = stripSizeAndParams(m.src1200);
        return mStripped === srcStripped;
      });

      if (mediaData) {
        // Użyj <picture> z responsywnym srcset dla lepszej jakości
        const picture = document.createElement('picture');

        // WebP source dla lepszej kompresji
        const sourceWebp = document.createElement('source');
        sourceWebp.type = 'image/webp';
        sourceWebp.srcset = mediaData.webp_srcset;
        sourceWebp.sizes = '100vw'; // Lightbox zawsze w pełnym ekranie
        picture.appendChild(sourceWebp);

        // Oryginalny format jako fallback
        const sourceOrig = document.createElement('source');
        sourceOrig.type = mediaData.mime_type || 'image/jpeg';
        sourceOrig.srcset = mediaData.original_srcset;
        sourceOrig.sizes = '100vw'; // Lightbox zawsze w pełnym ekranie
        picture.appendChild(sourceOrig);

        // IMG element
        const img = document.createElement('img');
        img.src = mediaData.src1200; // Fallback dla starszych przeglądarek
        img.alt = mediaData.alt || '';
        img.style.cursor = window.innerWidth < 768 ? 'default' : (zoomActive ? 'zoom-out' : 'zoom-in');
        picture.appendChild(img);

        lightboxMedia.appendChild(picture);

        // Dodaj event listeners do img wewnątrz picture
        img.addEventListener('load', () => {
          // Desktop: click to zoom
          if (window.innerWidth >= 768) {
            img.addEventListener('click', function (e) {
              e.stopPropagation();
              if (!zoomActive) {
                enableZoom(img);
              } else {
                disableZoom(img);
              }
            });
          }
        });
      } else {
        // Fallback dla przypadku gdy nie znaleziono mediaData
        const img = document.createElement('img');
        img.src = mediaList[currentIndex];
        img.style.cursor = window.innerWidth < 768 ? 'default' : (zoomActive ? 'zoom-out' : 'zoom-in');
        lightboxMedia.appendChild(img);
      }

      // Mobile: pinch-zoom do centrum obrazka, pan po powiększeniu
      if (window.innerWidth < 768) {
        // Znajdź aktualny obraz (może być w picture lub bezpośrednio)
        const currentImg = lightboxMedia.querySelector('img');
        if (currentImg) {
          // Pinch-zoom do centrum obrazka, pan po powiększeniu
          let zoomActiveMobile = false;
          let dragging = false, startX = 0, startY = 0;
          let baseOffsetX = 0, baseOffsetY = 0, offsetX = 0, offsetY = 0;
          let baseScale = 1, currentScale = 1;
          let initialDistance = 0;

          function getDistance(touches) {
            const dx = touches[0].clientX - touches[1].clientX;
            const dy = touches[0].clientY - touches[1].clientY;
            return Math.sqrt(dx * dx + dy * dy);
          }
          function clampOffset(val, scale, imgSize, viewportSize) {
            // Pozwól przesuwać tylko tyle, by nie wyjechać poza viewport
            const max = ((imgSize * scale) - viewportSize) / 2;
            if (max <= 0) return 0;
            return Math.max(-max, Math.min(max, val));
          }
          function updateTransform() {
            // Ogranicz przesuwanie do granic obrazka
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            const imgW = currentImg.naturalWidth || currentImg.width;
            const imgH = currentImg.naturalHeight || currentImg.height;
            offsetX = clampOffset(offsetX, currentScale, imgW, vw);
            offsetY = clampOffset(offsetY, currentScale, imgH, vh);
            currentImg.style.transform = `scale(${currentScale}) translate(${offsetX}px, ${offsetY}px)`;
          }
          function onTouchStart(e) {
            isInTouchEvent = true;
            if (e.touches.length === 1 && currentScale > 1) {
              // Start pan
              dragging = true;
              startX = e.touches[0].clientX - offsetX;
              startY = e.touches[0].clientY - offsetY;
            } else if (e.touches.length === 2) {
              // Start pinch
              e.preventDefault();
              zoomActiveMobile = true;
              initialDistance = getDistance(e.touches);
              baseScale = currentScale;
              hideZoomHint(); // Hide hint when user starts zooming
            }
          }
          function onTouchMove(e) {
            if (e.touches.length === 1 && dragging && currentScale > 1) {
              // Pan
              offsetX = (e.touches[0].clientX - startX) * 0.7;
              offsetY = (e.touches[0].clientY - startY) * 0.7;
              updateTransform();
              e.preventDefault();
            } else if (e.touches.length === 2) {
              // Pinch (do centrum obrazka)
              e.preventDefault();
              const newDistance = getDistance(e.touches);
              const scale = newDistance / initialDistance;
              currentScale = Math.max(1, Math.min(2.4, baseScale * scale));
              // Zawsze zoom do centrum, offset nie zmienia się przy pinch
              updateTransform();
            }
          }
          function onTouchEnd(e) {
            if (e.touches.length === 0) {
              dragging = false;
              isInTouchEvent = false; // Reset flag
              if (currentScale < 1.1) {
                currentScale = 1;
                offsetX = 0;
                offsetY = 0;
                baseOffsetX = 0;
                baseOffsetY = 0;
                baseScale = 1;
                currentImg.style.transform = 'scale(1)';
                zoomActiveMobile = false;
                // Show hint when zoomed out to minimum
                setTimeout(showZoomHint, 100); // Small delay to ensure transform is applied
              } else {
                // Zapamiętaj offsety po zakończeniu gestu
                baseOffsetX = offsetX;
                baseOffsetY = offsetY;
                baseScale = currentScale;
              }
            } else if (e.touches.length === 1 && currentScale > 1) {
              // Przechodzimy z pinch do pan
              dragging = true;
              startX = e.touches[0].clientX - offsetX;
              startY = e.touches[0].clientY - offsetY;
            }
          }
          lightboxMedia.addEventListener('touchstart', onTouchStart, { passive: false });
          lightboxMedia.addEventListener('touchmove', onTouchMove, { passive: false });
          lightboxMedia.addEventListener('touchend', onTouchEnd);
          lightboxMedia.addEventListener('touchcancel', onTouchEnd);
          // Tap poza obrazkiem wyłącza zoom jeśli aktywny
          lightboxMedia.addEventListener('click', function (e) {
            if (e.target !== currentImg && zoomActiveMobile) {
              currentScale = 1;
              offsetX = 0;
              offsetY = 0;
              baseOffsetX = 0;
              baseOffsetY = 0;
              baseScale = 1;
              currentImg.style.transform = 'scale(1)';
              zoomActiveMobile = false;
              // Show hint when zoom is reset
              showZoomHint();
            }
          });
        }
      }
      else if (zoomActive) {
        const currentImg = lightboxMedia.querySelector('img');
        if (currentImg) {
          enableZoom(currentImg);
        }
      }
    }
    counter.textContent = `${currentIndex + 1} / ${mediaList.length}`;
    prevButton.style.visibility = currentIndex === 0 ? 'hidden' : 'visible';
    nextButton.style.visibility = currentIndex === mediaList.length - 1 ? 'hidden' : 'visible';
  }

  // Add keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('active')) return;

    if (e.key === 'Escape') {
      lightbox.classList.remove('active');
      // USUŃ: blokada scrolla na mobile
      if (window.innerWidth < 768) {
        document.documentElement.classList.remove('lock');
      }
    } else if (e.key === 'ArrowLeft' && currentIndex > 0) {
      currentIndex--;
      updateLightboxContent();
    } else if (e.key === 'ArrowRight' && currentIndex < mediaList.length - 1) {
      currentIndex++;
      updateLightboxContent();
    }
  });

  prevButton.addEventListener('click', (e) => {
    e.stopPropagation();
    if (currentIndex > 0) {
      currentIndex--;
      updateLightboxContent();
      // Show hint for new image (starts at scale = 1)
      setTimeout(showZoomHint, 100);
    }
    hideZoomHint();
  });

  nextButton.addEventListener('click', (e) => {
    e.stopPropagation();
    if (currentIndex < mediaList.length - 1) {
      currentIndex++;
      updateLightboxContent();
      // Show hint for new image (starts at scale = 1)
      setTimeout(showZoomHint, 100);
    }
    hideZoomHint();
  });

  closeButton.addEventListener('click', (e) => {
    e.stopPropagation();
    lightbox.classList.remove('active');
    // USUŃ: blokada scrolla na mobile
    if (window.innerWidth < 768) {
      document.documentElement.classList.remove('lock');
    }
    hideZoomHint();
  });

  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) {
      lightbox.classList.remove('active');
      // USUŃ: blokada scrolla na mobile
      if (window.innerWidth < 768) {
        document.documentElement.classList.remove('lock');
      }
    }
    // Hide zoom hint on any click, but not during touch events
    if (!isInTouchEvent) {
      hideZoomHint();
    }
  });

  // Make updateLightboxContent available globally
  window.updateLightboxContent = updateLightboxContent;

  // Show hint when lightbox is opened (new image starts at scale = 1)
  if (window.innerWidth < 768) {
    setTimeout(showZoomHint, 100);
  }
}

function addBadgeToFirstImage(imageElement) {
  // Sprawdź czy imageElement istnieje
  if (!imageElement) {
    console.warn('addBadgeToFirstImage: imageElement is null');
    return;
  }

  const badgeTypeElement = document.querySelector('[data-badge-type]');
  if (!badgeTypeElement) {
    console.warn('addBadgeToFirstImage: data-badge-type element not found');
    return;
  }

  const badgeType = badgeTypeElement.dataset.badgeType;
  if (badgeType) {
    const badgeElement = document.createElement('div');
    badgeElement.classList.add('badge-wrapper');
    badgeElement.style.opacity = '1';

    // Parsuj badge'y (mogą być oddzielone przecinkami)
    const badges = badgeType.split(',').map(b => b.trim()).filter(b => b);
    
    // Funkcja do generowania HTML dla pojedynczego badge'a
    function getBadgeHTML(badgeType) {
      switch (badgeType) {
        case 'made-to-order':
          return `<span class="badge badge--product-gallery wg-translate made-to-order">Made to order</span>`;
        case 'bestseller':
          return `<span class="badge badge--product-gallery wg-translate bestsellers">Bestseller</span>`;
        case 'new-arrival':
          return `<span class="badge badge--product-gallery wg-translate new-arrivals">New</span>`;
        case 'pre-order':
          return `<span class="badge badge--product-gallery wg-translate pre-order">Pre-order</span>`;
        case 'coming-soon':
          return `<span class="badge badge--product-gallery wg-translate coming-soon">Coming Soon</span>`;
        case 'pro-collection':
          return `<span class="badge badge--product-gallery wg-translate pro-collection">Pro Collection</span>`;
        case 'sold-out':
          return `<span class="badge badge--product-gallery wg-translate sold-out">Sold Out</span>`;
        case 'sofa-beds':
          return `<span class="badge badge--product-gallery wg-translate sofa-beds">Sofa Beds</span>`;
        default:
          return '';
      }
    }

    // Zawsze najpierw sprawdź "sofa-beds", potem inne badge'y
    let badgeHTML = '';
    
    // Najpierw dodaj "sofa-beds" jeśli istnieje
    if (badges.includes('sofa-beds')) {
      badgeHTML += getBadgeHTML('sofa-beds');
    }
    
    // Potem dodaj pozostałe badge'y w kolejności
    const badgeOrder = ['made-to-order', 'bestseller', 'new-arrival', 'pre-order', 'coming-soon', 'pro-collection', 'sold-out'];
    for (const badge of badgeOrder) {
      if (badges.includes(badge) && badge !== 'sofa-beds') {
        badgeHTML += getBadgeHTML(badge);
      }
    }

    // Jeśli nie znaleziono żadnego znanego badge'a, użyj starej logiki (backward compatibility)
    if (!badgeHTML && badges.length === 1) {
      badgeHTML = getBadgeHTML(badges[0]);
    }

    badgeElement.innerHTML = badgeHTML;
    imageElement.appendChild(badgeElement);
  }
}

// Funkcja do obliczania i ustawiania stałej wysokości galerii mobilnej
function setMobileGalleryHeight(gallerySlider) {
  const productGalleryImg = document.querySelector('.product-gallery__img');

  if (mobileGalleryHeight === null && isInitialLoad) {
    // Usuń inline style.height, aby CSS mógł poprawnie obliczyć calc()
    productGalleryImg.style.height = '';
    gallerySlider.style.height = '';

    // Pobierz obliczoną wysokość z CSS (calc(100dvh - 212px)) tylko przy pierwszym załadowaniu
    const computedStyle = window.getComputedStyle(gallerySlider);
    const calculatedHeight = parseFloat(computedStyle.height);
    mobileGalleryHeight = calculatedHeight;
    isInitialLoad = false; // Oznacz, że pierwsze załadowanie już się odbyło
  }

  // Ustaw stałą wysokość w pikselach (jeśli została zapamiętana)
  if (mobileGalleryHeight !== null) {
    // Zapisz wysokość w CSS variables – zostanie użyta w stylach
    document.documentElement.style.setProperty('--mobile-gallery-height', `${mobileGalleryHeight}px`);
    gallerySlider.style.setProperty('--gallery-height', `${mobileGalleryHeight}px`);
    gallerySlider.classList.add('static-height-forced');
  }
}

// Add resize handler to switch between mobile and desktop layouts
let resizeTimeout;
let lastWindowWidth = window.innerWidth;
window.addEventListener('resize', () => {
  const currentWidth = window.innerWidth;
  const widthChanged = Math.abs(currentWidth - lastWindowWidth) > 50; // Only update if width changed by more than 50px

  if (widthChanged) {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      lastWindowWidth = currentWidth;
      // Reset wysokości przy znaczących zmianach rozmiaru
      mobileGalleryHeight = null;
      updateVariantGallery();
    }, 250); // Wait 250ms after resize stops
  }
});

// Reset gallery state on page reload
window.addEventListener('beforeunload', () => {
  isGalleryExpanded = false;
});

document.addEventListener('DOMContentLoaded', updateVariantGallery);
document.addEventListener('variant:change', updateVariantGallery);